import { render, staticRenderFns } from "./SelectSavedQueryModal.vue?vue&type=template&id=116f070c"
import script from "./SelectSavedQueryModal.vue?vue&type=script&lang=js"
export * from "./SelectSavedQueryModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports